/**
 * 로그인 사용자의 CMS 메뉴 트리에 "테마 관리" 화면이 포함되는지 판별합니다.
 * DB/권한에 따라 메뉴가 내려오므로, 동일 권한을 가진 system 계정 등도 자동 반영됩니다.
 */

const THEME_MANAGEMENT_PAGE_TYPES = new Set(['theme-management']);

/** URL 슬러그가 DB 메뉴 href와 다를 수 있어 병행 매칭 */
const THEME_MANAGEMENT_HREF_SLUGS = new Set(['theme-management', 'theme-setting']);

function extractSlugFromHref(href) {
  if (!href || typeof href !== 'string') return null;
  const trimmed = href.split(/[?#]/)[0];
  const dbIdx = trimmed.indexOf('/db/page/');
  if (dbIdx >= 0) {
    const rest = trimmed.slice(dbIdx + '/db/page/'.length);
    return rest.replace(/^\/+|\/+$/g, '') || null;
  }
  const pageIdx = trimmed.indexOf('/page/');
  if (pageIdx >= 0) {
    const rest = trimmed.slice(pageIdx + '/page/'.length);
    return rest.replace(/^\/+|\/+$/g, '') || null;
  }
  return null;
}

function nodeIndicatesThemeManagement(node) {
  if (!node || typeof node !== 'object') return false;
  const pageType = node.pageType ?? node.PAGE_TYPE;
  if (pageType && THEME_MANAGEMENT_PAGE_TYPES.has(String(pageType))) return true;
  const componentType = node.componentType ?? node.COMPONENT_TYPE;
  if (componentType && THEME_MANAGEMENT_PAGE_TYPES.has(String(componentType))) return true;
  const href = node.href ?? node.HREF ?? node.menuUrl ?? node.MENU_URL ?? node.path ?? node.PATH;
  if (href) {
    const slug = extractSlugFromHref(href);
    if (slug && THEME_MANAGEMENT_HREF_SLUGS.has(slug)) return true;
  }
  return false;
}

/**
 * @param {unknown} menuData - useMenuData().menuData
 * @returns {boolean}
 */
export function menuTreeHasThemeManagementAccess(menuData) {
  if (!Array.isArray(menuData) || menuData.length === 0) return false;
  const stack = [...menuData];
  while (stack.length) {
    const node = stack.pop();
    if (nodeIndicatesThemeManagement(node)) return true;
    const children = node.children ?? node.CHILDREN ?? node.subMenus ?? node.subMenuList ?? node.nodes;
    if (Array.isArray(children)) {
      for (let i = 0; i < children.length; i += 1) stack.push(children[i]);
    }
  }
  return false;
}
